/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestTypeVo } from './RequestTypeVo';
import {
    RequestTypeVoFromJSON,
    RequestTypeVoFromJSONTyped,
    RequestTypeVoToJSON,
    RequestTypeVoToJSONTyped,
} from './RequestTypeVo';

/**
 * 
 * @export
 * @interface ResponseListRequestTypeVo
 */
export interface ResponseListRequestTypeVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListRequestTypeVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListRequestTypeVo
     */
    message?: string;
    /**
     * 
     * @type {Array<RequestTypeVo>}
     * @memberof ResponseListRequestTypeVo
     */
    data?: Array<RequestTypeVo>;
}

/**
 * Check if a given object implements the ResponseListRequestTypeVo interface.
 */
export function instanceOfResponseListRequestTypeVo(value: object): value is ResponseListRequestTypeVo {
    return true;
}

export function ResponseListRequestTypeVoFromJSON(json: any): ResponseListRequestTypeVo {
    return ResponseListRequestTypeVoFromJSONTyped(json, false);
}

export function ResponseListRequestTypeVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListRequestTypeVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(RequestTypeVoFromJSON)),
    };
}

export function ResponseListRequestTypeVoToJSON(json: any): ResponseListRequestTypeVo {
    return ResponseListRequestTypeVoToJSONTyped(json, false);
}

export function ResponseListRequestTypeVoToJSONTyped(value?: ResponseListRequestTypeVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(RequestTypeVoToJSON)),
    };
}

